import { Link } from "react-router-dom";
import { ArrowRight, Check, MapPin } from "lucide-react";
import Chapter from "./Chapter";
import { Reveal } from "./Reveal";
import { CASE_STUDIES } from "../data/caseStudies";
import { useLang } from "../i18n";

export const CaseStudies = ({ index = "" }) => {
  const { t } = useLang();
  const c = t.caseStudies;

  return (
    <section className="mx-auto max-w-[1760px] px-5 py-20 sm:px-8 sm:py-28" data-testid="case-studies">
      <Chapter index={index} label={c.label} title={c.title} lead={c.lead} />
      <div className="mt-12 grid gap-6 lg:grid-cols-3">
        {CASE_STUDIES.map((cs, i) => (
          <Reveal
            key={cs.id}
            delay={i * 0.1}
            className="group flex flex-col border border-[#DDE4EA] bg-white transition-all duration-500 hover:-translate-y-1 hover:border-[#0F5C8C]/50 hover:shadow-[0_28px_60px_-40px_rgba(14,27,36,0.55)]"
            data-testid={`case-study-${cs.id}`}
          >
            <div className="relative h-40 overflow-hidden border-b border-[#DDE4EA]">
              <img
                src={cs.image}
                alt={cs.title}
                loading="lazy"
                className="h-full w-full object-cover opacity-80 transition-transform duration-[1.2s] group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 bg-[#0E1B24]/90 px-2.5 py-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-white">
                {cs.sector}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-7">
              <p className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#0F5C8C]">
                <MapPin size={12} /> {cs.country}
              </p>
              <h3 className="font-display mt-2 text-xl font-extrabold leading-tight tracking-tight nv-head">{cs.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#41535F]">{cs.scope}</p>
              <ul className="mt-5 space-y-2 border-t border-[#DDE4EA] pt-5">
                {cs.points.map((p) => (
                  <li key={p} className="flex gap-2 text-[13px] leading-relaxed text-[#41535F]">
                    <Check size={14} className="mt-0.5 shrink-0 text-[#0F5C8C]" /> {p}
                  </li>
                ))}
              </ul>
              <Link
                to="/contact#enquiry"
                data-testid={`case-study-cta-${cs.id}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0F5C8C] transition-colors hover:text-[#0A3E63]"
              >
                {c.cta} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 border-l-2 border-[#C8D3DB] pl-4 text-xs leading-relaxed text-[#6B7C88]" data-testid="case-studies-note">{c.note}</p>
    </section>
  );
};

export default CaseStudies;
